import axios from 'axios';

// 第一个代理基础路径配置


// 第二个代理基础路径配置
export const videos = axios.create({
    baseURL:'/video'
});
// videos.defaults.timeout = 20000;
videos.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

export default axios;


// WEBPACK FOOTER //
// ./src/components/axios/videos.js